import { message } from "antd";

export const showErrorMessage = (content, duration = 3, onClose = () => {}) => {
  message.error(content, duration, onClose);
};
